module.exports = __webpack_public_path__ + "assets/img/wallet-icon1-s.1bf532c2.png";